/* eslint-disable react/prop-types */
import { forwardRef, ReactElement } from 'react'
import { VideoProps } from './props'
import { StyledIframe, StyledVideo, YoutubeContainer } from './styles'

const Video = forwardRef<HTMLVideoElement, VideoProps>(
    (props, ref): ReactElement => {
        const { autoPlay, controls, loop, muted, playsInline, src } = props
        const regExp =
            // eslint-disable-next-line no-useless-escape
            /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/
        const match = src?.match(regExp)

        if (match && match[2].length == 11) {
            const autoplay = autoPlay ? '&autoplay=1' : ''
            const controlsPanel = !controls ? '&controls=0' : ''
            const looped = loop ? '&loop=1' : ''
            const mute = muted ? '&mute=1' : ''
            const playsinline = playsInline ? '&playsinline=1' : ''

            return (
                <YoutubeContainer>
                    <StyledIframe
                        src={`https://www.youtube.com/embed/${match[2]}?rel=0&showinfo=0&modestbranding=1${autoplay}${controlsPanel}${looped}${mute}${playsinline}`}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        frameBorder="0"
                    />
                </YoutubeContainer>
            )
        }

        return (
            <StyledVideo {...props} role="application" ref={ref}>
                <div>Your browser does not support the video tag.</div>
            </StyledVideo>
        )
    }
)

Video.displayName = 'Video'

export default Video

export { StyledVideo }
